module.exports = __webpack_public_path__ + "img/note-taking.9db2c10f.svg";